import React from "react";
import FullImage from "../Modal/FullImage";

function ImageMessage({ src, alt }) {
  const [view, setView] = React.useState(false);

  return (
    <>
      <img
        src={"" + src}
        alt={alt}
        className="img-fluid rounded"
        style={{ maxWidth: "300px", maxHeight: "300px" }}
        onClick={() => setView(true)}
      />
      {view && (
        <FullImage
          show={view}
          image={"" + src}
          onHide={() => setView(false)}
          imageType={"image"}
        />
      )}
    </>
  );
}

export default ImageMessage;
